import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import BottomNavigation from './BrandCampaignLayout/BottomNavigation';
import { getAllRegion } from "../../../store/campaignStore/actions/CampaignMasterActions/getAllRegionActions";
import { getAllAgeGroup } from "../../../store/campaignStore/actions/CampaignMasterActions/getAllAgeGroupActions";
import { getAllNiche } from "../../../store/campaignStore/actions/CampaignMasterActions/getAllNicheActions";
import { getCountryByRegion } from "../../../store/campaignStore/actions/CampaignMasterActions/getCountryByRegionActions";
import { getStateByCountry } from "../../../store/campaignStore/actions/CampaignMasterActions/getStateByCountryActions";
import {
    setBrandCampaignCreationData,
    setBrandCampaignCreationStep
} from "../../../store/publicStore/actions/utilsActions/utilsActions";
import './AudienceDemographicDetails.css';
import MultiSelectDropdown from '../../common/MultiSelectDropdown/MultiSelectDropdown';
import { getCityByState } from "../../../store/campaignStore/actions/CreateCampaignActions/getCityByStateActions";


const AudienceDemographicDetails = () => {
    const dispatch = useDispatch()

    const { brandCampaignCreationStep, brandCampaignCreationData } = useSelector((state) => state.utilReducers);

    const getAllRegionReducerData = useSelector(state => state.getAllRegionReducer.data);
    const getCountryByRegionReducerData = useSelector(state => state.getCountryByRegionReducer?.data);
    const getStateByCountryReducerData = useSelector(state => state.getStateByCountryReducer?.data);
    const getCityByStateReducerData = useSelector(state => state.getCityByStateReducer?.data);
    const getAllAgeGroupReducerData = useSelector(state => state.getAllAgeGroupReducer?.data);
    const getAllNicheReducerData = useSelector(state => state.getAllNicheReducer?.data);

    // Normalize values that might have been stored as objects in redux to primitive IDs
    const normalizeId = (v) => {
        if (v && typeof v === 'object') {
            return `${v.regionId ?? v.countryId ?? v.stateId ?? v.id ?? ''}`;
        }
        return `${v ?? ''}`;
    };

    const regionRef = useRef(normalizeId(brandCampaignCreationData?.audienceDemographicDetails?.region));
    const countryRef = useRef(normalizeId(brandCampaignCreationData?.audienceDemographicDetails?.country));
    const stateRef = useRef(normalizeId(brandCampaignCreationData?.audienceDemographicDetails?.state));

    const [formData, setFormData] = useState({
        region: normalizeId(brandCampaignCreationData?.audienceDemographicDetails?.region),
        country: normalizeId(brandCampaignCreationData?.audienceDemographicDetails?.country),
        state: normalizeId(brandCampaignCreationData?.audienceDemographicDetails?.state),
        ageGroup: brandCampaignCreationData?.audienceDemographicDetails?.ageGroup ? brandCampaignCreationData?.audienceDemographicDetails?.ageGroup : '',
        gender: brandCampaignCreationData?.audienceDemographicDetails?.gender ? brandCampaignCreationData?.audienceDemographicDetails?.gender : '',
        niche: brandCampaignCreationData?.audienceDemographicDetails?.niche ? brandCampaignCreationData?.audienceDemographicDetails?.niche : '',
        platform: brandCampaignCreationData?.basicDetails?.platform ? brandCampaignCreationData?.basicDetails?.platform : '',
        city: normalizeId(brandCampaignCreationData?.audienceDemographicDetails?.city),
    });

    console.log("brandCampaignCreationData?.audienceDemographicDetails?.region", brandCampaignCreationData?.audienceDemographicDetails?.region ? brandCampaignCreationData?.audienceDemographicDetails?.region : '');
    const [formErrors, setFormErrors] = useState({});

    useEffect(() => {
        const regionVal = normalizeId(brandCampaignCreationData?.audienceDemographicDetails?.region);
        if (!regionVal) {
            dispatch(getAllRegion());
        }
        dispatch(getAllAgeGroup());
        dispatch(getAllNiche());
    }, []);

    // On initial mount, if region/country/state already exist (coming back to the page),
    // fetch their dependent dropdown options so the selects can render their values.
    useEffect(() => {
        if (formData?.region) {
            dispatch(getCountryByRegion({ regionId: normalizeId(formData.region) }));
        }
        if (formData?.country) {
            dispatch(getStateByCountry({ countryId: normalizeId(formData.country) }));
        }
        if (formData?.platform === "INSTAGRAM" && formData?.state) {
            dispatch(getCityByState({ stateId: normalizeId(formData.state) }));
        }
    }, []);


    useEffect(() => {
        if (formData.region?.length > 0 && regionRef.current !== formData.region) {
            regionRef.current = formData.region;
            dispatch(getCountryByRegion({ regionId: normalizeId(formData.region) }));
            setFormData((prevData) => ({
                ...prevData,
                country: '',
                state: '',
            }));
        }
    }, [formData.region]);


    useEffect(() => {
        if (formData.country?.length > 0 && countryRef.current !== formData.country) {
            countryRef.current = formData.country;
            dispatch(getStateByCountry({ countryId: normalizeId(formData.country) }));
            setFormData((prevData) => ({
                ...prevData,
                state: '',
                city: '',
            }));
        }
    }, [formData.country]);

    // When state changes and platform is INSTAGRAM, fetch cities for that state
    useEffect(() => {
        if (formData.platform === "INSTAGRAM" && formData.state?.length > 0) {
            // Always fetch cities for the current state so options are available on back navigation
            dispatch(getCityByState({ stateId: normalizeId(formData.state) }));

            // Only treat as a real change when state actually differs from previous, but do NOT clear city here.
            // City clearing is already handled in handleChange when user selects a different state.
            if (stateRef.current !== formData.state) {
                stateRef.current = formData.state;
            }
        }
    }, [formData.state, formData.platform]);

    // Validate the form and return errors
    const validateBannerForm = (data) => {
        let formErrors = {};

        if (data?.ageGroup?.length === 0) {
            formErrors.ageGroup = "Age Group is required";
        }
        if (!data?.country.trim()) {
            formErrors.country = "Country is required";
        }
        if (data?.niche?.length === 0 && data?.platform === 'YOUTUBE') {
            formErrors.niche = "Niche is required";
        }
        if (!data?.region.trim()) {
            formErrors.region = "Region is required";
        }
        if (!data?.gender.trim()) {
            formErrors.gender = "Gender is required";
        }
        // Require city when platform is INSTAGRAM
        // if (data?.platform === 'INSTAGRAM' && !`${data?.city ?? ''}`.trim()) {
        //     formErrors.city = "City is required";
        // }
        return formErrors;
    };

    const handleNext = () => {

        // Validate form data
        const formErrors = validateBannerForm(formData);

        if (Object.keys(formErrors).length > 0) {
            setFormErrors(formErrors); // Show errors if validation fails
        } else {
            // Clear errors and save data to Redux store
            setFormErrors({});

            // Dispatch the campaign data to Redux
            dispatch(
                setBrandCampaignCreationData({
                    basicDetails: {
                        campaignName: brandCampaignCreationData?.basicDetails?.campaignName,
                        campaignPurpose: brandCampaignCreationData?.basicDetails?.campaignPurpose,
                        platform: brandCampaignCreationData?.basicDetails?.platform,
                        campaignType: brandCampaignCreationData?.basicDetails?.campaignType,
                        referralCode: brandCampaignCreationData?.basicDetails?.referralCode,
                        selectedBrandId: brandCampaignCreationData?.basicDetails?.selectedBrandId,
                    },
                    contentDetails: {
                        startDate: brandCampaignCreationData?.contentDetails?.startDate,
                        endDate: brandCampaignCreationData?.contentDetails?.endDate,
                        bannerTemplate: brandCampaignCreationData?.contentDetails?.bannerTemplate,
                        selectedBannerName: brandCampaignCreationData?.contentDetails?.selectedBannerName,
                        videoPosition: brandCampaignCreationData?.contentDetails?.videoPosition,
                        mediaFileLink: brandCampaignCreationData?.contentDetails?.mediaFileLink,
                        mediaFileName: brandCampaignCreationData?.contentDetails?.mediaFileName,
                        script: brandCampaignCreationData?.contentDetails?.script,
                        dialogue: brandCampaignCreationData?.contentDetails?.dialogue,
                        backgroundColor: brandCampaignCreationData?.contentDetails?.backgroundColor,
                        otherProperties: brandCampaignCreationData?.contentDetails?.otherProperties,
                        isLocationRequired: brandCampaignCreationData?.contentDetails?.isLocationRequired,
                        isBrandApprovalRequired: brandCampaignCreationData?.contentDetails?.isBrandApprovalRequired,
                        uploadDuration: brandCampaignCreationData?.contentDetails?.uploadDuration,
                        videoTitle: brandCampaignCreationData?.contentDetails?.videoTitle,
                        videoDescription: brandCampaignCreationData?.contentDetails?.videoDescription,
                        selectedGenre: brandCampaignCreationData?.contentDetails?.selectedGenre,
                        referenceVideoUpload: brandCampaignCreationData?.contentDetails?.referenceVideoUpload,
                        descriptionLink: brandCampaignCreationData?.contentDetails?.descriptionLink,
                    },
                    audienceDemographicDetails: {
                        ageGroup: formData?.ageGroup,
                        country: formData?.country,
                        niche: formData?.niche,
                        region: formData?.region,
                        gender: formData?.gender,
                        state: formData?.state,
                        city: formData?.city,
                    }
                })
            );

            // Proceed to the next step
            dispatch(
                setBrandCampaignCreationStep(brandCampaignCreationStep + 1)
            );
        }
    };

    const handleChange = (e) => {
        const { id, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [id]: value,
            ...(id === 'state' ? { city: '' } : {}),
        }));
        setFormErrors((prevState) => { const { [id]: _, ...updatedObject } = prevState; return updatedObject; });
    };

    const handleSelect = (items, key) => {
        setFormData({
            ...formData,
            [key]: items?.map(item => (item.id))
        });
        setFormErrors((prevState) => { const { [key]: _, ...updatedObject } = prevState; return updatedObject; });
    };

    return (
        <div className="w-full h-[80%] bg-[#FFFFFF66] shadow-xl shadow-[#E3E8EF] rounded-[0.6rem] p-[3.2rem]">
            <div className="w-full h-full !overflow-y-scroll no-scrollbar">
                <h2 className="text-[2rem] text-[#111729] inter-font font-[500] mb-6">Geography</h2>
                <form onSubmit={() => { }}>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                        <div>
                            <label htmlFor="region" className="text-[1.6rem] text-[#111729] inter-font font-[400]">Region<span className="text-red-500">*</span></label>
                            <select
                                id="region"
                                value={`${formData.region ?? ''}`}
                                onChange={handleChange}
                                className="w-full px-4 py-4 text-[1.6rem] inter-font font-[400] border border-gray-300 rounded-lg focus:outline-none"
                                required
                            >
                                <option value="">Select Region</option>
                                {Array.isArray(getAllRegionReducerData) && getAllRegionReducerData.map((items) => (
                                    <option key={items.regionId} value={`${items.regionId}`}>
                                        {items.name}
                                    </option>
                                ))}
                            </select>
                            {formErrors.region && <span className=" text-[1.6rem] inter-font font-[400] text-red-500">{formErrors.region}</span>}
                        </div>
                        <div>
                            <label htmlFor="country" className="text-[1.6rem] text-[#111729] inter-font font-[400]">Country<span className="text-red-500">*</span></label>
                            <select
                                id="country"
                                value={`${formData.country ?? ''}`}
                                onChange={handleChange}
                                className="w-full px-4 py-4 text-[1.6rem] inter-font font-[400] border border-gray-300 rounded-lg focus:outline-none" required>
                                <option value="" >{!formData.region ? "Select region to choose" : "Select from Option"}</option>
                                {Array.isArray(getCountryByRegionReducerData) && getCountryByRegionReducerData.map((items) => (
                                    <option key={items.countryId} value={`${items.countryId}`}>
                                        {items.countryName}
                                    </option>
                                ))}
                                {/* Fallback: if current value is not in the list yet, show it so the select isn't blank */}
                                {formData.country && Array.isArray(getCountryByRegionReducerData) && !getCountryByRegionReducerData.some((i) => `${i.countryId}` === `${formData.country}`) && (
                                    <option value={`${formData.country}`}>{`Selected (${formData.country})`}</option>
                                )}
                            </select>
                            {formErrors.country && <span className="text-[1.6rem] inter-font font-[400] text-red-500">{formErrors.country}</span>}
                        </div>
                        <div>
                            <label htmlFor="state" className="text-[1.6rem] text-[#111729] inter-font font-[400]">State</label>
                            <select
                                id="state"
                                value={`${formData.state ?? ''}`}
                                onChange={handleChange}
                                className="w-full px-4 py-4 text-[1.6rem] inter-font font-[400] border border-gray-300 rounded-lg focus:outline-none"
                                required
                            >
                                <option value="">
                                    {!formData.country ? "Select country to choose" : "Select from Option"}
                                </option>
                                {Array.isArray(getStateByCountryReducerData) &&
                                    getStateByCountryReducerData
                                        .slice() // create a shallow copy so original array isn’t mutated
                                        .sort((a, b) => a.name.localeCompare(b.name)) // sort by name ASC
                                        .map((items) => (
                                            <option key={items.stateId} value={`${items.stateId}`}>
                                                {items.name}
                                            </option>
                                        ))}
                            </select>

                            {formErrors.state && <span className="text-[1.6rem] inter-font font-[400] text-red-500">{formErrors.state}</span>}
                        </div>
                        {formData?.platform === "INSTAGRAM" && (
                            <div>
                                <label htmlFor="city" className="text-[1.6rem] text-[#111729] inter-font font-[400]">City</label>
                                <select
                                    id="city"
                                    value={`${formData.city ?? ''}`}
                                    onChange={handleChange}
                                    className="w-full px-4 py-4 text-[1.6rem] inter-font font-[400] border border-gray-300 rounded-lg focus:outline-none"
                                    required
                                >
                                    {formData.state ? (
                                        <option value="">
                                            Select from Option
                                        </option>
                                    ) : (
                                        <option value="" disabled>
                                            Select State to choose
                                        </option>
                                    )}
                                    {Array.isArray(getCityByStateReducerData) &&
                                        getCityByStateReducerData
                                            .slice()
                                            .sort((a, b) => (a.name || a.cityName || "").localeCompare(b.name || b.cityName || ""))
                                            .map((items) => {
                                                const optionValue = items.cityId;
                                                const optionLabel = items.name ?? optionValue;
                                                return (
                                                    <option key={optionValue} value={`${optionValue}`}>
                                                        {optionLabel}
                                                    </option>
                                                );
                                            })}
                                </select>

                                {formErrors.city && (
                                    <span className="text-[1.6rem] inter-font font-[400] text-red-500">{formErrors.city}</span>
                                )}
                            </div>
                        )}
                    </div>

                    <h2 className="text-[2rem] text-[#111729] inter-font font-[500] mt-[4rem] mb-6">Viewer Demographics</h2>

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                        <div>
                            <label htmlFor="ageGroup" className="text-[1.6rem] text-[#111729] inter-font font-[400]">
                                Age Group<span className="text-red-500">*</span>
                            </label>
                            <MultiSelectDropdown
                                options={getAllAgeGroupReducerData.map((items) => (
                                    { ...items, id: items.ageGroupId, label: items.ageRangeLabel }
                                ))}
                                onSelect={(items) => handleSelect(items, 'ageGroup')}
                                preselectedOptions={getAllAgeGroupReducerData
                                    .filter((item) => formData.ageGroup.includes(item.ageGroupId)) // Ensure selectedIds is defined
                                    .map((item) => ({
                                        ...item,
                                        id: item.ageGroupId,
                                        label: item.ageRangeLabel,
                                    }))}
                            />
                            {formErrors.ageGroup && (
                                <span className="text-[1.6rem] inter-font font-[400] text-red-500">
                                    {formErrors.ageGroup}
                                </span>
                            )}
                        </div>

                        <div>
                            <label htmlFor="gender" className="text-[1.6rem] text-[#111729] inter-font font-[400]">Gender<span className="text-red-500">*</span></label>
                            <select id="gender" value={formData.gender} onChange={handleChange} className="w-full px-4 py-4 text-[1.6rem] inter-font font-[400] border border-gray-300 rounded-lg focus:outline-none" required>
                                <option value="">Select from Option</option>
                                <option value="MALE">Male</option>
                                <option value="FEMALE">Female</option>
                                <option value="OTHER">Other</option>
                                <option value="ALL">All</option>
                            </select>
                            {formErrors.gender && <span className="text-[1.6rem] inter-font font-[400] text-red-500">{formErrors.gender}</span>}
                        </div>
                        {formData?.platform !== "INSTAGRAM" && (
                            <div>
                                <label htmlFor="niche" className="text-[1.6rem] text-[#111729] inter-font font-[400]">Niche<span className="text-red-500">*</span></label>
                                <MultiSelectDropdown
                                    options={getAllNicheReducerData.map((items) => (
                                        { ...items, id: items.nicheId, label: items.nicheName }
                                    ))}
                                    onSelect={(items) => handleSelect(items, 'niche')}
                                    preselectedOptions={getAllNicheReducerData
                                        .filter((item) => formData.niche.includes(item.nicheId)) // Ensure selectedIds is defined
                                        .map((item) => ({
                                            ...item,
                                            id: item.nicheId,
                                            label: item.nicheName,
                                        }))}
                                />
                                {formErrors.niche && <span className="text-[1.6rem] inter-font font-[400] text-red-500">{formErrors.niche}</span>}
                            </div>
                        )}
                    </div>

                    <BottomNavigation isNextDisabled={Object.keys(formErrors).length > 0} handleNext={handleNext} />
                </form>
            </div>
        </div>
    );
};

export default AudienceDemographicDetails;
